import { User } from '@/modules/User/interfaces/user'
import { File } from '@/modules/File/interfaces/file'
import { Account } from '@/modules/Account/interfaces/account'

export enum AccountCertificateType {
  ID_CARD = 'ID_CARD',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  SSN = 'SSN',
  DDC = 'DDC',
  MVR = 'MVR',
  OTHER = 'OTHER',
}

export interface AccountCertificate {
  id: number;
  name: string;
  notes: string;
  type: AccountCertificateType;
  accountId: number;
  idNumber: string;
  ssn: string;
  firstName: string;
  middleName: string;
  lastName: string;
  licenseNumber: string;
  expirationDate: string;
  createdAt: number;
  updatedAt: number;
  account: Account;
  createdBy: User;
  lastModifiedBy: User;
  files: File[];
}
